<svg [attr.width]="width" [attr.height]="height" viewBox="0 0 10 10">
  <g [attr.fill]="color">
    <rect width="10" height="10" rx="5"/>
  </g>
</svg>
